The identifier for the closed `PositionProfile`.
